module.exports = __webpack_public_path__ + "static/mtb-10-9c91af96d9279d4ca69a413f278130c5.jpg";